import React, { useState } from 'react'
import { DataTable, useSidePanel } from '@node-space/ui-components'
import { useTransactionsContext } from 'hooks/context/useTransactionsContext'
import { useWalletContext } from 'hooks/context/useWalletContext'
import { RefundSheet } from 'pages/Wallets/components/Refunds/components/RefundSheet'
import { getIsPartiallyRefundable } from 'pages/Wallets/components/Refunds/utils'
import { WalletSheet } from 'pages/Wallets/components/Sheet/WalletSheet'
import { Transaction } from 'types/transaction'
import useTransactionTableData from './hooks/useTransactionTableData'
import { SidePanelSummary } from './SidePanel/SidePanelSummary'

export const TransactionTable = () => {
  const transactions = useTransactionsContext()
  const wallet = useWalletContext()

  const [isRefundSheetOpen, setIsRefundSheetOpen] = useState(false)
  const [isSheetOpen, setIsSheetOpen] = useState(false)
  const [selectedTransaction, setSelectedTransaction] = useState<Transaction | undefined>()
  const [isPartiallyRefundable, setIsPartiallyRefundable] = useState(false)

  const {
    isSidePanelOpen: isTransactionDetailsSidepanelOpen,
    sidePanelData: transactionDetails,
    paging: transactionsPaging,
    setIsSidePanelOpen: setIsTransactionDetailsSidepanelOpen,
    updateSidePanel: updateTransactionDetailsSidepanel,
  } = useSidePanel(transactions)

  const openSidePanelSummary = (index: number) => {
    updateTransactionDetailsSidepanel(index)
    setIsTransactionDetailsSidepanelOpen(true)
  }

  const openRefundSheet = (transaction: Transaction) => {
    setSelectedTransaction(transaction)
    if (!transaction) {
      return
    }

    const isPartiallyRefundable = getIsPartiallyRefundable(transaction)
    setIsPartiallyRefundable(isPartiallyRefundable)

    setIsRefundSheetOpen(true)
  }

  const { columns, tableData } = useTransactionTableData({
    transactions,
    openSidePanelSummary,
    openRefundSheet,
  })

  return (
    <>
      <DataTable name="SimpleTable" headers={columns} data={tableData} />
      {!!transactionDetails && (
        <SidePanelSummary
          isOpen={isTransactionDetailsSidepanelOpen}
          paging={transactionsPaging}
          onClose={() => setIsTransactionDetailsSidepanelOpen(false)}
          transactionDetails={transactionDetails}
        />
      )}
      {isRefundSheetOpen && (
        <>
          <RefundSheet
            wallet={wallet}
            transaction={selectedTransaction}
            isRefundSheetOpen={isRefundSheetOpen}
            setIsRefundSheetOpen={setIsRefundSheetOpen}
            setIsSheetOpen={setIsSheetOpen}
            isPartiallyRefundable={isPartiallyRefundable}
          />
          <WalletSheet isSheetOpen={isSheetOpen} />
        </>
      )}
    </>
  )
}
